import { t } from 'i18next';
import { ClientType, EditClientFormValues } from './types';
import { ApiParams, ApiResps } from '~/providers';
import { Info } from '../ClientHeader';

export const defaultFormValues: EditClientFormValues = {
  name: '',
  email: '',
  cnpj: '',
  phone: '',
  clientType: '',
  picture: '',
  enabled: false,
  clientOwner: null,
};

export const FORM_VALIDATORS = {
  name: {
    required: t('campoNomeNecessario'),
  },
  email: {
    required: t('campoEmailNecessario'),
  },
  phone: {
    required: false,
    validate: (value: string): boolean | string => {
      if (value) {
        const regex = new RegExp(/^\([0-9]{2}\) [0-9]?[0-9]{4}-[0-9]{4}$/);
        return regex.test(value) || t('telefoneInvalido');
      } return true;
    },
  },
  cnpj: {
    required: false,
    validate: (value: string): boolean | string => {
      if (value) {
        const regex = new RegExp(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/);
        return regex.test(value) || t('cnpjInvalido');
      } return true;
    },
  },
};

export const buildParamsByFormData = (formValues: EditClientFormValues): ApiParams['/clients/add-new-client'] => {
  const params: ApiParams['/clients/add-new-client'] = {
    EMAIL: formValues.email,
    NAME: formValues.name,
    PICTURE: formValues.picture,
    clientType: [formValues.clientType as ClientType],
    ENABLED: formValues.enabled ? '1' : '0',
    CNPJ: formValues.cnpj,
    PHONE: formValues.phone,
    CLIENT_OWNER: formValues.clientOwner ? { value: formValues.clientOwner } : undefined,
  };

  return params;
};

export const buildFormDataByInfo = (info:Info): EditClientFormValues => ({
  clientType: info.clientType,
  email: info.email,
  enabled: info.enabled,
  name: info.name,
  picture: info.picture,
  phone: handleEmptyValueToForm(info.phone),
  cnpj: handleEmptyValueToForm(info.cnpj),
  clientOwner: info.clientOwner ?? null,
});

const handleEmptyValueToForm = (value: string | undefined | null): string => (value && value !== '-' ? value : '');

export const buildClientType = (clientType: ApiResps['/clients/get-client-info']['client']['clientType'], fabricante?: boolean): ClientType => {
  let auxClientType: ClientType | null = fabricante ? 'fabricante' : 'cliente';
  const type = clientType ?? [];

  if (type.includes('cliente')) auxClientType = 'cliente';
  if (type.includes('mantenedor')) auxClientType = 'mantenedor';
  if (type.includes('fabricante')) auxClientType = 'fabricante';
  if (type.includes('parceira')) auxClientType = 'parceira';
  if (type.includes('sub-cliente')) auxClientType = 'sub-cliente';

  return auxClientType;
};
